<template>
  <div>
    <div class="banner_box">
      <joinpartbanner></joinpartbanner>
    </div>
    <div class="detail_box">
      <div class="join_detail">
        <div class="join_title">
          {{$t("join.programmer")}}
        </div>
        <div class="company_name">
          {{$t("join.companyname")}}
        </div>
        <div class="work_property">
          <span class="work_property1">{{$t("join.worknature")}}<span class="work_property2">{{$t("join.fulltime")}}</span></span>
          <span class="work_property1">{{$t("join.salary")}}<span class="work_property2">{{$t("join.programmermoney")}}</span></span>
          <span class="work_property1">{{$t("join.education")}}<span class="work_property2">{{$t("join.specialist")}}</span></span>
          <span class="work_property1">{{$t("join.workyears")}}<span class="work_property2">{{$t("join.oneyears")}}</span></span>
        </div>
        <div class="job_content">
          <div class="job_describe">
            <div class="job_describe_title">
              {{$t("join.positiondescribe")}}
            </div>
            <div class="job_describe_ul">
              <ul>
                <li>
                  <p>基于Unity引擎，制作实现VR虚拟显示产品中的交互功能</p>
                </li>
                <li>
                  <p>负责程序架构的搭建</p>
                </li>
                <li>
                  <p>负责项目的系统逻辑、用户界面，以及图形特效的程序开发</p>
                </li>
                <li>
                  <p>进行部分Unity3D中的功能扩展和开发</p>
                </li>
                <li>
                  <p>配合团队其他人员进行项目开发</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="job_describe">
            <div class="job_describe_title">
              {{$t("join.positionclaim")}}
            </div>
            <div class="job_describe_ul">
              <ul>
                <li>
                  <p>大专以上学历，2年以上Unity3D开发经验者优先</p>
                </li>
                <li>
                  <p>熟练掌握Unity3D开发引擎</p>
                </li>
                <li>
                  <p>熟练掌握C#语言和面向对象编程，有良好的面向对象编码思想</p>
                </li>
                <li>
                  <p>对Unity3D编程架构有较深入理解</p>
                </li>
                <li>
                  <p>有Unity3D网页开发经验者或了解基础3d模型软件（如maya，3d max）优先</p>
                </li>
                <li>
                  <p>责任感强，富有团队精神，善于学习和自我提高，能独立解决问题，有积极的工作态度</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="job_location">
          {{$t('join.location')}}
        </div>
         <div class="job_return" align="center">
          <div @mouseenter="enter" @mouseleave="leave" :class="isflag==true?'job_return_div1':'job_return_div'"><a
              @click="setroters('/join/index')">返回列表</a></div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import joinpartbanner from "@/components/contentcoms/joincontentcoms/joinpartbanner";
  export default {
    name: "intern",
    components: {joinpartbanner},
     data() {
      return {
        isflag: false
      }
    },
    methods: {
      setroters(src) {
        this.$router.push(src);
      },
      enter: function () {
        this.isflag = true;
      },
      leave: function () {
        this.isflag = false;
      }
    }
  }
</script>

<style scoped>
  .detail_box{
    margin: 0 auto;
    width: 1200px;
    padding-top: 50px;
  }
  .join_title{
    font-size: 24px;
    color: #333333;
    padding-bottom: 20px;
  }
  .company_name{
    font-size: 14px;
    color: #B6B6B6;
    text-align: left;
    padding-bottom: 16px;
    border-bottom: 1px solid #FBFBFB;
  }
  .work_property{
    padding: 22px 0px 22px 20px;
    text-align: left;
    border-bottom: 1px solid #FBFBFB;
  }
  .work_property1{
    font-size: 16px;
    color: #666666;
    padding-right: 110px;
  }
  .work_property2{
    font-size: 16px;
    color: #333333;
  }
  .job_content{
    padding-bottom: 30px;
    border-bottom: 1px solid #FBFBFB;
  }
  .job_describe{
    text-align: left;
    padding: 30px 0px 30px 20px;
  }
  .job_describe_ul{
    padding-top: 18px;
  }
  .job_describe_ul ul {
    color: #2E79BE;
  }
  .job_describe_ul p {
    font-size: 16px;
    color: #666666;
  }
  .job_location{
    text-align: left;
    font-size: 16px;
    color: #333333;
    padding: 20px 0px 20px 20px;
    border-bottom: 1px solid #FBFBFB;
  }
  .job_return{
    margin-top: 10px;
  }

  .job_return a{
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/joincontentcoms/programmer.vue